import * as yup from 'yup';
import { cnpj, cpf } from 'cpf-cnpj-validator';

export const schema = yup.object({
  name: yup
    .string()
    .required('Seu nome é obrigatório')
    .min(3, 'Digite seu nome completo')
    .test('fullName', 'Digite seu nome completo', value =>
      value ? value?.trim().split(' ').length > 1 : false),
      
  email: yup.string().email('Digite um email válido').required('Seu email é obrigatório'),

  confirmEmail: yup
  .string()
  .required('Confirmação de email obrigatória')
  .oneOf([yup.ref('email')], 'Os emails não coincidem'),
  
  document: yup
    .string()
    .required('Documento do titular é obrigatório')
    .test('isCpfCnpj', 'Documento inválido', value => {
      if (cnpj.strip(value).length > 11) {
        return cnpj.isValid(cpf.strip(value));
      }
      return cpf.isValid(cnpj.strip(value));
    }),
}).required();